<div class="form-container">
  <div class="cardLayout">

    <!-- Header Section -->
    <ion-row class="align-center justify-between header-bar">

  <!-- Left: Title -->
  <ion-col size="8" class="ion-text-start">
    <div class="form-title">Asset Management</div>
  </ion-col>

  <!-- Right: Refresh & Close -->
  <ion-col size="4" class="ion-text-end">

    <!-- Refresh Icon -->
    <span class="ml-5 fs-20 material-icons btn-reset mr-2"
      style="cursor:pointer;"
      [class.clicked]="isClicked"
      (click)="resetGrid()"
      (animationend)="isClicked = false">
      refresh
    </span>

    <!-- Close Icon -->
    <img [mat-dialog-close] 
      src="././assets/icon/close_icon.png"
      class="close-icon cp ml-3"
      alt="close" />
  </ion-col>

</ion-row>

    <!-- AG Grid Section -->
    <mat-sidenav-container class="sidenav-container">
      <mat-sidenav-content>
        <ag-grid-angular
          class="ag-theme-quartz custom-ag-grid"
          [rowData]="userListDataForAsset?.users"
          [columnDefs]="columnDefs"
          [gridOptions]="gridOptions"
          [defaultColDef]="defaultColDef"
          (gridReady)="onGridReady($event)"
          (rowClicked)="onRowClicked($event)"
          (cellClicked)="onCelledClicked($event)"
          (cellValueChanged)="onCellValueChanged($event)"
          [pagination]="pagination"
          [paginationPageSize]="paginationPageSize"
          [paginationPageSizeSelector]="paginationPageSizeSelector"
          [detailRowAutoHeight]="detailRowAutoHeight"
          [localeText]="{ noRowsToShow: 'No Data Found' }">
        </ag-grid-angular>
      </mat-sidenav-content>
    </mat-sidenav-container>

    <!-- Action Buttons -->
    <ion-row class="action-row">
      <ion-col size="12" class="text-right">
        <button class="btn cancel-btn" (click)="cancelData()">Cancel</button>
        <button type="button" class="btn save-btn ml-10" [style.background-color]="buttonColorName"
          (click)="updateDataByHr()">
          Save
        </button>
      </ion-col>
    </ion-row>

  </div>
</div>
